export default __webpack_public_path__ + "src/static/img/png/arch-blue-section-one-v2.png";